import { COLORS } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorDiscussionQuestionSelectionBody = dynamic(
  () => import('../../new-portal/ai-tutor/AITutorDiscussionQuestion'),
  {
    loading: () => (
      <div className="flex h-screen w-screen items-center justify-center">
        <LoadingSpinner lg show primary />
      </div>
    ),
  }
)

const AITutorDiscussionQuestionSelectionTobNav = () => {
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const appRouter = useAppRouter({ stackPush: push, browserDetect: true })
  const { t } = useTranslation()

  return (
    <div className="flex w-screen flex-row items-center justify-start py-[12px] px-[20px]">
      <div className="">
        <QIcon_chevron_left width={'24px'} height={'24px'} color={COLORS.BLACK} onClick={() => appRouter.back()} />
      </div>
    </div>
  )
}

const AITutorDiscussionQuestionSelectionActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const courseId = router.query?.courseId
  const threadId = router.query?.threadId

  return (
    <WebviewStackContainer height="52px" title={<AITutorDiscussionQuestionSelectionTobNav />} border={false}>
      <AITutorDiscussionQuestionSelectionBody courseId={courseId} threadId={threadId} />
    </WebviewStackContainer>
  )
}

export default AITutorDiscussionQuestionSelectionActivity
